import { Spinner } from "./icons";

/*
  Figma "Button" (DS · კომპონენტები): Style Filled | Tinted | Gray | Plain × Size S | M | L.
  Filled is the one main action on a screen, Tinted the secondary, Gray neutral,
  Plain text-only, Danger for what can't be undone. Hover and pressed lay the label colour over the button at
  8% / 14% (the Figma "State layer"). Loading shows a spinner and a present-tense
  label, keeps the button's look and width, and blocks presses.
*/

const VARIANTS = {
  filled: "bg-accent-default text-accent-on",
  tinted: "bg-accent-tinted text-accent-tinted-label",
  gray: "bg-fill-secondary text-label-primary",
  plain: "text-accent-text",
  danger: "bg-status-danger text-white",
};

const DISABLED = {
  danger: "bg-fill-quaternary text-label-tertiary",
  filled: "bg-fill-quaternary text-label-tertiary",
  tinted: "bg-fill-quaternary text-label-tertiary",
  gray: "bg-fill-quaternary text-label-tertiary",
  plain: "text-label-tertiary",
};

const SIZES = {
  s: "h-button-s gap-space-4 px-space-12 text-caps-button-s",
  m: "h-button-m gap-space-8 px-space-16 text-caps-button-m",
  l: "h-button-l gap-space-8 px-space-20 text-caps-button-l",
};

const BASE = [
  "relative inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-radius-md uppercase outline-none",
  // State layer
  "after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:bg-current after:opacity-0 after:transition-opacity",
  "enabled:hover:after:opacity-[var(--state-hover)] enabled:active:after:opacity-[var(--state-pressed)]",
  // Focus ring: 2px, 4px outside the button, radius/lg
  "before:pointer-events-none before:absolute before:-inset-1 before:rounded-radius-lg before:border-2 before:border-focus-ring before:opacity-0 focus-visible:before:opacity-100",
].join(" ");

const Button = ({
  variant = "filled",
  size = "l",
  icon = null,
  loading = false,
  disabled = false,
  fullWidth = false,
  type = "button",
  className = "",
  children,
  ...rest
}) => {
  const look = disabled && !loading ? DISABLED[variant] : VARIANTS[variant];
  const cursor = loading ? "cursor-wait" : disabled ? "cursor-not-allowed" : "cursor-pointer";
  const iconBox = size === "s" ? "size-4" : "size-5";

  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`${BASE} ${SIZES[size]} ${look} ${cursor} ${fullWidth ? "w-full" : ""} ${className}`}
      {...rest}
    >
      {loading ? (
        <Spinner size={size === "s" ? 16 : 20} />
      ) : (
        icon && <span className={`flex ${iconBox} shrink-0 items-center justify-center`}>{icon}</span>
      )}
      <span>{children}</span>
    </button>
  );
};

export default Button;
